import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import CustomStore from 'devextreme/data/custom_store';
import DxDataSource from 'devextreme/data/data_source';

import { DataSource } from '@/types';
import {
    TableComponent, TableComponentProps, TableColumn, columnTemplates, TableConfig
} from '@/core/components/table';
import {
    RelocationLimit, IRelocationLimitsTableData, LocalizationKeys
} from '../classes';

@Component({})
export class RelocationLimitsTable
    extends Vue {

    private static readonly TABLE_KEY = 'relocation-limits-table';

    @Prop({ type: Object, required: true })
    private data?: IRelocationLimitsTableData;

    private mounted(): void {
        if (!this.data) { throw new Error('data is not set'); }
    }

    private render(createElement: Vue.CreateElement): Vue.VNode {
        return createElement(TableComponent, {
            props: {
                tableKey: RelocationLimitsTable.TABLE_KEY,
                dataSource: this.dataSource,
                columns: this.columns,
                tableConfig: this.tableConfig,
            } as TableComponentProps,
            on: {
                ...this.$listeners,
            },
        });
    }

    private onSelectionChanged(e: any): void {
        this.data!.selectedRelocationLimits = e.selectedRowsData;
    }

    private get columns(): TableColumn[] {
        return [
            {
                dataField: 'channel.name',
                caption: LocalizationKeys.TableColumnChannelName,
            },
            {
                dataField: 'startJsDate',
                caption: LocalizationKeys.TableColumnStartDate,
                calculateCellValue: (rowData) => {
                    return new Date(rowData.startJsDate);
                },
                ...columnTemplates.DATE_WITH_TIME(),
            },
            {
                dataField: 'endJsDate',
                caption: LocalizationKeys.TableColumnEndDate,
                calculateCellValue: (rowData) => {
                    return new Date(rowData.endJsDate);
                },
                ...columnTemplates.DATE_WITH_TIME(),
            },
            {
                dataField: 'volume',
                caption: LocalizationKeys.TableColumnVolume,
                ...columnTemplates.VOLUME(),
            },
            {
                dataField: 'weightLimit',
                caption: LocalizationKeys.TableColumnWeightLimit,
                ...columnTemplates.WEIGHT(),
            },
        ];
    }
    private get tableConfig(): Partial<TableConfig> {
        return {
            selection: {
                mode: 'multiple',
                showCheckBoxesMode: 'always'
            },
            onSelectionChanged: e => this.onSelectionChanged(e),
        };
    }

    private get dataSource(): DataSource {
        const me = this;

        const store = new CustomStore({
            load: () => me.getRelocationLimits(),
            loadMode: 'raw',
        });
        // TODO paging
        const result = new DxDataSource({
            paginate: false,
            select: (item: RelocationLimit) => {
                return {
                    startJsDate: item.startDate.toDate(),
                    endJsDate: item.endDate.toDate(),
                    ...item,
                };
            },
            store,
        });

        return result;
    }
    private async getRelocationLimits(): Promise<RelocationLimit[]> {
        const data = this.data!;
        if (data.promiseLoad) {
            await data.promiseLoad;
        }
        const result = data.relocationLimits ? data.relocationLimits : [];

        return result;
    }
}
